(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var setHeight = function () {
      document.documentElement.style.setProperty('--announcement-h', bar.offsetHeight + 'px');
    };
    setHeight();
    window.addEventListener('resize', setHeight);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-classes-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.classes-page');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      return;
    }
    root.classList.add('classes-page--js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('classes-page__rv--in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    root.querySelectorAll('.classes-page__rv').forEach(function (el) { io.observe(el); });

    root.querySelectorAll('.classes-page__map').forEach(function (box) {
      var btn = box.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var q = box.getAttribute('data-q') || '';
        var f = document.createElement('iframe');
        f.src = 'https://www.google.com/maps?q=' + encodeURIComponent(q) + '&output=embed';
        f.title = 'Χάρτης του ατελιέ';
        f.loading = 'lazy';
        f.referrerPolicy = 'no-referrer-when-downgrade';
        box.innerHTML = '';
        box.style.border = '0';
        box.appendChild(f);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.contact-page');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('contact-page--js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('contact-page__rv--in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      root.querySelectorAll('.contact-page__rv').forEach(function (el) { io.observe(el); });
    }

    root.querySelectorAll('.contact-page__map').forEach(function (box) {
      var btn = box.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var q = box.getAttribute('data-q') || '';
        var f = document.createElement('iframe');
        f.src = 'https://www.google.com/maps?q=' + encodeURIComponent(q) + '&output=embed';
        f.title = 'Χάρτης: το ατελιέ στο Χαριλάου Θεσσαλονίκης';
        f.loading = 'lazy';
        f.referrerPolicy = 'no-referrer-when-downgrade';
        box.innerHTML = '';
        box.style.border = '0';
        box.appendChild(f);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-creator-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.creator-page');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('creator-page--js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('creator-page__rv--in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      root.querySelectorAll('.creator-page__rv').forEach(function (el) { io.observe(el); });
    }

    root.querySelectorAll('.creator-page__video').forEach(function (box) {
      var btn = box.querySelector('.creator-page__video-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = box.getAttribute('data-yt');
        if (!id) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        f.title = 'Βίντεο';
        f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        box.innerHTML = '';
        box.appendChild(f);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-header"]) return;
  try {
    
  document.querySelectorAll('[data-atelier-header]').forEach(function (header) {
    var toggle = header.querySelector('[data-atelier-header-toggle]');
    var dialog = header.querySelector('[data-atelier-header-dialog]');
    var closeBtn = header.querySelector('[data-atelier-header-close]');
    var label = header.querySelector('[data-atelier-header-toggle-label]');

    if (toggle && dialog) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          dialog.close();
        } else {
          dialog.showModal();
          toggle.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = toggle.getAttribute('data-close-label');
        }
      });

      dialog.addEventListener('close', function () {
        toggle.setAttribute('aria-expanded', 'false');
        if (label) label.textContent = toggle.getAttribute('data-open-label');
        toggle.focus();
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }
    }

    if (header.classList.contains('atelier-header--transparent')) {
      var onScroll = function () {
        header.classList.toggle('is-solid', window.scrollY > 40);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-nav"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function trapItems(drawer) {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled])')
      );
    }

    function setupNav(root) {
      if (!root || root.getAttribute('data-nt-ready') === 'true') return;
      root.setAttribute('data-nt-ready', 'true');
      root.classList.add('nt-js');

      var burger = root.querySelector('[data-nt-burger]');
      var drawer = document.getElementById('nt-drawer');
      var overlay = document.querySelector('[data-nt-overlay]');
      var closeBtn = drawer ? drawer.querySelector('[data-nt-close]') : null;
      if (!burger || !drawer || !overlay) return;

      var openLabel = burger.getAttribute('data-open-label') || '';
      var closeLabel = burger.getAttribute('data-close-label') || '';
      var lastFocused = null;

      function onKeydown(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closeDrawer();
          return;
        }
        if (event.key === 'Tab') {
          var items = trapItems(drawer);
          if (!items.length) return;
          var first = items[0];
          var last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }

      function onOverlayClick() {
        closeDrawer();
      }

      function openDrawer(fromKeyboard) {
        lastFocused = document.activeElement;
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.removeAttribute('inert');
        burger.setAttribute('aria-expanded', 'true');
        burger.setAttribute('aria-label', closeLabel);
        document.body.style.overflow = 'hidden';
        // Με πληκτρολόγιο εστιάζουμε στον πρώτο σύνδεσμο. Με αφή/ποντίκι εστιάζουμε
        // στο ίδιο το συρτάρι, ώστε να μη φαίνεται το χρυσό focus πλαίσιο.
        var navLinks = drawer.querySelectorAll('nav a[href]');
        if (fromKeyboard && navLinks.length) navLinks[0].focus();
        else drawer.focus({ preventScroll: true });
        document.addEventListener('keydown', onKeydown);
        overlay.addEventListener('click', onOverlayClick);
      }

      function closeDrawer() {
        if (!drawer.classList.contains('is-open')) return;
        drawer.classList.remove('is-open');
        overlay.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', openLabel);
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKeydown);
        overlay.removeEventListener('click', onOverlayClick);
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      burger.addEventListener('click', function (event) {
        if (drawer.classList.contains('is-open')) closeDrawer();
        else openDrawer(event.detail === 0);
      });
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      Array.prototype.forEach.call(drawer.querySelectorAll('nav a'), function (link) {
        link.addEventListener('click', closeDrawer);
      });

      drawer.setAttribute('inert', '');
    }

    function init() {
      Array.prototype.forEach.call(
        document.querySelectorAll('.nt-nav[data-section-id]'),
        setupNav
      );
    }

    /* Απόκρυψη στην κύλιση προς τα κάτω / εμφάνιση προς τα πάνω σε οθόνες
       ως 1000px. Στον υπολογιστή ισχύει μόνο σε σελίδες με στοιχείο
       [data-nav-hide-after] (π.χ. Πινακοθήκη), και αφού η κύλιση περάσει το
       κάτω άκρο του. Ένας listener για όλο το έγγραφο, ώστε να επιβιώνει
       από το shopify:section:load του theme editor. */
    function setupAutoHide() {
      var mobile = window.matchMedia('(max-width: 1000px)');
      var lastY = window.scrollY;
      var ticking = false;
      var THRESHOLD = 8;

      /* Τα ύψη μετριούνται μόνο σε load/resize και όχι σε κάθε frame κύλισης:
         ένα offsetHeight/getBoundingClientRect μέσα στο scroll αναγκάζει τον
         browser σε layout σε κάθε frame και κάνει την μπάρα να «κολλάει». */
      var navH = 0;
      var anchorBottom = null;

      function measure() {
        var nav = document.querySelector('.nt-nav');
        navH = nav ? nav.offsetHeight : 0;
        var anchor = document.querySelector('[data-nav-hide-after]');
        anchorBottom = anchor ? anchor.getBoundingClientRect().bottom + window.scrollY : null;
      }

      function setHidden(hidden) {
        var wrapper = document.querySelector('.nt-nav-section');
        if (wrapper) wrapper.classList.toggle('is-nav-hidden', hidden);
      }

      function update() {
        ticking = false;
        if (!navH) measure();
        /* Το y περιορίζεται στο πραγματικό εύρος κύλισης: στο iOS το
           «λάστιχο» στην αρχή/στο τέλος της σελίδας δίνει τιμές εκτός ορίων,
           που διαβάζονταν σαν κύλιση προς τα πάνω και τρεμόπαιζε η μπάρα. */
        var maxY = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
        var y = Math.min(Math.max(window.scrollY, 0), maxY);
        var drawer = document.getElementById('nt-drawer');
        var drawerOpen = drawer && drawer.classList.contains('is-open');

        var active = mobile.matches;
        if (!active) {
          active = anchorBottom !== null && y + navH >= anchorBottom;
        }

        if (!active || drawerOpen || y <= navH) {
          setHidden(false);
        } else if (y > lastY + THRESHOLD) {
          setHidden(true);
        } else if (y < lastY - THRESHOLD) {
          setHidden(false);
        } else {
          return;
        }
        lastY = y;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }, { passive: true });

      function remeasure() {
        measure();
        update();
      }

      measure();
      window.addEventListener('resize', remeasure);
      window.addEventListener('load', remeasure);
      document.addEventListener('shopify:section:load', remeasure);
      if (mobile.addEventListener) mobile.addEventListener('change', remeasure);

      // Αν το πληκτρολόγιο φέρει focus μέσα στη μπάρα, την ξαναδείχνουμε.
      document.addEventListener('focusin', function (event) {
        if (event.target.closest && event.target.closest('.nt-nav')) setHidden(false);
      });
    }

    ready(init);
    ready(setupAutoHide);

    document.addEventListener('shopify:section:load', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var root = document.querySelector('.nt-nav[data-section-id="' + id + '"]');
      if (root) {
        root.removeAttribute('data-nt-ready');
        root.classList.remove('nt-js');
        setupNav(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-pigments-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.pigments-page');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('pigments-page--js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pigments-page__rv--in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      root.querySelectorAll('.pigments-page__rv').forEach(function (el) { io.observe(el); });
    }

    var track = root.querySelector('.pigments-page__sets');
    var tabs = root.querySelectorAll('.pigments-page__set-tab');
    var cards = root.querySelectorAll('[data-set-card]');
    var current = root.querySelector('[data-set-current]');
    var prevBtns = root.querySelectorAll('[data-set-prev]');
    var nextBtns = root.querySelectorAll('[data-set-next]');
    var viewport = root.querySelector('[data-sets-viewport]');
    if (track && tabs.length && cards.length) {
      var active = 0;
      // Buttons follow the real scroll position: on desktop several cards are
      // visible at once, so the last card is "reached" before index hits the end.
      var updateEdges = function () {
        var x = track.scrollLeft;
        var atStart = x <= 2;
        var atEnd = x + track.clientWidth >= track.scrollWidth - 2;
        if (viewport) {
          viewport.classList.toggle('is-start', atStart);
          viewport.classList.toggle('is-end', atEnd);
        }
        prevBtns.forEach(function (b) { b.disabled = atStart; });
        nextBtns.forEach(function (b) { b.disabled = atEnd; });
      };
      updateEdges();
      window.addEventListener('resize', updateEdges, { passive: true });

      var touched = false;
      ['pointerdown', 'wheel', 'keydown'].forEach(function (ev) {
        track.addEventListener(ev, function () { touched = true; }, { passive: true, once: true });
      });
      if (!reduce && cards.length > 1 && 'IntersectionObserver' in window) {
        var nudgeIo = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          nudgeIo.disconnect();
          setTimeout(function () {
            if (touched || track.scrollLeft > 2 || track.scrollWidth <= track.clientWidth) return;
            track.style.scrollSnapType = 'none';
            track.scrollTo({ left: 72, behavior: 'smooth' });
            setTimeout(function () {
              track.scrollTo({ left: 0, behavior: 'smooth' });
              setTimeout(function () { track.style.scrollSnapType = ''; }, 500);
            }, 520);
          }, 900);
        }, { threshold: 0.6 });
        nudgeIo.observe(track);
      }
      var setActive = function (idx) {
        if (idx === active) return;
        active = idx;
        tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
        if (current) current.textContent = idx + 1;
        var tab = tabs[idx];
        var bar = tab.parentNode;
        bar.scrollTo({ left: tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      };
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var x = track.scrollLeft;
          var pad = parseFloat(getComputedStyle(track).paddingLeft);
          var best = 0;
          var bestDist = Infinity;
          cards.forEach(function (c, i) {
            var d = Math.abs(c.offsetLeft - pad - x);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          if (x + track.clientWidth >= track.scrollWidth - 2) best = cards.length - 1;
          setActive(best);
          updateEdges();
        });
      }, { passive: true });
      var goTo = function (i) {
        i = Math.max(0, Math.min(cards.length - 1, i));
        var pad = parseFloat(getComputedStyle(track).paddingLeft);
        track.scrollTo({ left: cards[i].offsetLeft - pad, behavior: reduce ? 'auto' : 'smooth' });
        setActive(i);
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { goTo(i); });
      });
      prevBtns.forEach(function (b) { b.addEventListener('click', function () { goTo(active - 1); }); });
      nextBtns.forEach(function (b) { b.addEventListener('click', function () { goTo(active + 1); }); });
    }

    var list = root.querySelector('.pigments-page__palette');
    var wrap = root.querySelector('.pigments-page__more-wrap');
    var btn = wrap ? wrap.querySelector('.pigments-page__more-btn') : null;
    if (list && wrap && btn) {
      var rows = list.querySelectorAll('.pigments-page__chip');
      var VISIBLE = 8;
      if (rows.length > VISIBLE) {
        for (var i = VISIBLE; i < rows.length; i++) rows[i].classList.add('pigments-page__chip--more');
        list.classList.add('pigments-page__palette--collapsed');
        btn.textContent = 'Δες και τα υπόλοιπα ' + (rows.length - VISIBLE);
        wrap.hidden = false;
        btn.addEventListener('click', function () {
          list.classList.remove('pigments-page__palette--collapsed');
          wrap.hidden = true;
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(nav) {
      if (nav.getAttribute('data-ready') === 'true') return;
      var grid = nav.previousElementSibling;
      if (!grid || !grid.classList.contains('atelier-works__grid')) return;
      var items = grid.children;
      if (items.length < 2) return;
      nav.setAttribute('data-ready', 'true');

      var prev = nav.querySelector('[data-works-prev]');
      var next = nav.querySelector('[data-works-next]');
      var index = nav.querySelector('[data-works-i]');
      nav.querySelector('[data-works-total]').textContent = items.length;
      nav.hidden = false;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;

      function currentIndex() {
        var left = grid.getBoundingClientRect().left;
        var best = 0;
        var bestDistance = Infinity;
        for (var i = 0; i < items.length; i++) {
          var distance = Math.abs(items[i].getBoundingClientRect().left - left);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        }
        return best;
      }

      function render() {
        index.textContent = current + 1;
        prev.disabled = current === 0;
        next.disabled = current === items.length - 1;
      }

      function go(i) {
        current = Math.max(0, Math.min(items.length - 1, i));
        var target = items[current];
        grid.scrollTo({
          left: target.offsetLeft - grid.offsetLeft - (grid.clientWidth - target.offsetWidth) / 2,
          behavior: reduce ? 'auto' : 'smooth'
        });
        render();
      }

      prev.addEventListener('click', function () { go(current - 1); });
      next.addEventListener('click', function () { go(current + 1); });

      var ticking = false;
      grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          current = currentIndex();
          render();
        });
      }, { passive: true });

      render();
    }

    function init() {
      document.querySelectorAll('[data-works-nav]').forEach(setup);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;

    var dialog = null;
    var openTrigger = null;

    function announce(text) {
      var liveRegion = root.querySelector('[data-cart-live-region]');
      if (!liveRegion || !text) return;
      liveRegion.textContent = '';
      window.setTimeout(function () {
        liveRegion.textContent = text;
      }, 50);
    }

    function bindStepper(stepper) {
      var line = stepper.getAttribute('data-line');
      var max = stepper.getAttribute('data-max');
      var input = stepper.querySelector('[data-cart-stepper-input]');
      var decrease = stepper.querySelector('[data-cart-stepper-decrease]');
      var increase = stepper.querySelector('[data-cart-stepper-increase]');

      function apply(value) {
        value = Math.max(1, value);
        if (max) value = Math.min(parseInt(max, 10), value);
        changeLine(line, value, root.getAttribute('data-live-qty-updated'));
      }

      if (decrease) {
        decrease.addEventListener('click', function () {
          apply((parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          apply((parseInt(input.value, 10) || 1) + 1);
        });
      }
      if (input) {
        input.addEventListener('change', function () {
          apply(parseInt(input.value, 10) || 1);
        });
      }
    }

    function bindDialog() {
      dialog = root.querySelector('[data-cart-drawer-dialog]');
      if (!dialog) return;

      dialog.addEventListener('close', function () {
        if (openTrigger) {
          openTrigger.focus();
          openTrigger = null;
        }
      });

      dialog.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          dialog.close();
        });
      });

      dialog.querySelectorAll('[data-cart-stepper]').forEach(bindStepper);

      dialog.querySelectorAll('[data-cart-drawer-remove]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          changeLine(btn.getAttribute('data-line'), 0, root.getAttribute('data-live-item-removed'));
        });
      });
    }

    function refresh(open) {
      fetch(window.location.pathname + '?sections=cart-drawer,header')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data['cart-drawer']) {
            var newDoc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
            var newRoot = newDoc.querySelector('[data-cart-drawer]');
            if (newRoot) {
              var hasUnique = newRoot.getAttribute('data-cart-has-unique') === 'true';
              root.innerHTML = newRoot.innerHTML;
              root.setAttribute('data-cart-has-unique', hasUnique ? 'true' : 'false');
              bindDialog();

              if (open) {
                if (hasUnique) {
                  window.location.href = root.getAttribute('data-cart-url');
                } else if (dialog) {
                  dialog.showModal();
                }
              }
            }
          }

          if (data['header']) {
            var headerDoc = new DOMParser().parseFromString(data['header'], 'text/html');
            var newIcon = headerDoc.querySelector('[data-cart-icon]');
            var currentIcon = document.querySelector('[data-cart-icon]');
            if (newIcon && currentIcon) {
              currentIcon.innerHTML = newIcon.innerHTML;
            }
          }
        });
    }

    function changeLine(line, quantity, message) {
      fetch(root.getAttribute('data-cart-change-url'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function () {
        announce(message);
        refresh(true);
      });
    }

    document.addEventListener('cart:refresh', function (event) {
      var open = !event.detail || event.detail.open !== false;
      refresh(open);
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-cart-drawer-open]');
      if (!trigger) return;
      event.preventDefault();

      if (root.getAttribute('data-cart-has-unique') === 'true') {
        window.location.href = root.getAttribute('data-cart-url');
        return;
      }

      openTrigger = trigger;
      if (dialog) dialog.showModal();
    });

    bindDialog();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    var changeUrl = root.getAttribute('data-cart-change-url');
    var addUrl = root.getAttribute('data-cart-add-url');
    var ledeUnique = root.getAttribute('data-lede-unique');
    var ledePaint = root.getAttribute('data-lede-paint');
    var threshold = parseInt(root.getAttribute('data-shipping-threshold-cents'), 10) || 0;
    var shipFreeText = root.getAttribute('data-shipping-free');
    var shipPendingText = root.getAttribute('data-shipping-pending');
    var shipProgressTpl = root.getAttribute('data-shipping-progress-note');
    var shipDoneText = root.getAttribute('data-shipping-done-note');
    var itemCountOne = root.getAttribute('data-item-count-one');
    var itemCountOtherTpl = root.getAttribute('data-item-count-other');
    var undoTpl = root.getAttribute('data-undo-removed-template');
    var liveQtyMsg = root.getAttribute('data-live-qty-updated');
    var liveRemoveMsg = root.getAttribute('data-live-item-removed');

    var fullEl = root.querySelector('[data-cart-full]');
    var emptyEl = root.querySelector('[data-cart-empty]');
    var linesEl = root.querySelector('[data-cart-lines]');
    var holdEl = root.querySelector('[data-cart-hold]');
    var shipEl = root.querySelector('[data-cart-ship]');
    var shipTextEl = root.querySelector('[data-cart-ship-text]');
    var shipFillEl = root.querySelector('[data-cart-ship-fill]');
    var shipCellEl = root.querySelector('[data-cart-ship-cell]');
    var countEl = root.querySelector('[data-cart-count]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var totalEl = root.querySelector('[data-cart-total]');
    var ledeEl = root.querySelector('[data-cart-lede]');
    var undoEl = root.querySelector('[data-cart-undo]');
    var undoTextEl = root.querySelector('[data-cart-undo-text]');
    var undoBtn = root.querySelector('[data-cart-undo-btn]');
    var stickyBar = root.querySelector('[data-cart-sticky-bar]');
    var stickyTotalEl = root.querySelector('[data-cart-sticky-total]');
    var liveRegion = document.querySelector('[data-cart-live-region]');

    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function announce(text) {
      if (!liveRegion || !text) return;
      liveRegion.textContent = '';
      window.setTimeout(function () {
        liveRegion.textContent = text;
      }, 50);
    }

    function visibleLines() {
      return Array.prototype.slice.call(linesEl.querySelectorAll('.cart-line-item:not([hidden])'));
    }

    function refreshHeaderIcon() {
      fetch(window.location.pathname + '?sections=header')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data.header) return;
          var newIcon = new DOMParser().parseFromString(data.header, 'text/html').querySelector('[data-cart-icon]');
          var currentIcon = document.querySelector('[data-cart-icon]');
          if (newIcon && currentIcon) currentIcon.innerHTML = newIcon.innerHTML;
        });
    }

    function updateSummary(cart) {
      if (cart.item_count === 0) {
        if (fullEl) fullEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (stickyBar) stickyBar.hidden = true;
        return;
      }

      var hasUnique = visibleLines().some(function (li) {
        return li.getAttribute('data-kind') === 'unique';
      });

      if (holdEl) holdEl.hidden = !hasUnique;

      if (shipEl) {
        if (hasUnique) {
          shipEl.hidden = true;
          if (shipCellEl) shipCellEl.textContent = shipFreeText;
        } else {
          shipEl.hidden = false;
          var paintSub = 0;
          visibleLines().forEach(function (li) {
            if (li.getAttribute('data-kind') !== 'unique') {
              paintSub += parseInt(li.getAttribute('data-line-price'), 10) || 0;
            }
          });
          var left = threshold - paintSub;
          if (threshold > 0 && left > 0) {
            shipEl.classList.remove('is-done');
            if (shipTextEl) shipTextEl.textContent = shipProgressTpl.replace('[[amount]]', money(left));
            if (shipFillEl) shipFillEl.style.width = Math.max(4, (paintSub / threshold) * 100) + '%';
            if (shipCellEl) shipCellEl.textContent = shipPendingText;
          } else {
            shipEl.classList.add('is-done');
            if (shipTextEl) shipTextEl.textContent = shipDoneText;
            if (shipFillEl) shipFillEl.style.width = '100%';
            if (shipCellEl) shipCellEl.textContent = shipFreeText;
          }
        }
      }

      if (countEl) {
        countEl.textContent = cart.item_count === 1 ? itemCountOne : itemCountOtherTpl.replace('[[count]]', cart.item_count);
      }
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      if (totalEl) totalEl.textContent = money(cart.total_price);
      if (stickyTotalEl) stickyTotalEl.textContent = money(cart.total_price);
      if (stickyBar) stickyBar.hidden = false;
      if (ledeEl) ledeEl.textContent = hasUnique ? ledeUnique : ledePaint;
    }

    function findLine(variantId) {
      return linesEl.querySelector('.cart-line-item[data-variant-id="' + variantId + '"]');
    }

    function applyCartResponse(cart, variantId) {
      var li = findLine(variantId);
      if (li) {
        var responseItem = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].variant_id) === String(variantId)) {
            responseItem = cart.items[i];
            break;
          }
        }
        if (responseItem) {
          li.classList.remove('is-leaving');
          li.hidden = false;
          li.setAttribute('data-qty', responseItem.quantity);
          li.setAttribute('data-line-price', responseItem.line_price);
          var amountEl = li.querySelector('[data-cart-amount]');
          if (amountEl) amountEl.textContent = money(responseItem.line_price);
          var input = li.querySelector('[data-cart-stepper-input]');
          if (input) input.value = responseItem.quantity;
        } else {
          if (!li.hidden) fadeOutLine(li);
          li.setAttribute('data-line-price', 0);
        }
      }
      updateSummary(cart);
      refreshHeaderIcon();
    }

    function changeQuantity(variantId, quantity, message) {
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          announce(message);
          applyCartResponse(cart, variantId);
        });
    }

    var lastRemoved = null;
    var undoTimer = null;

    // Η γραμμή σβήνει ομαλά πριν κρυφτεί (βλ. .cart-line-item.is-leaving).
    function fadeOutLine(li) {
      li.classList.add('is-leaving');
      window.setTimeout(function () {
        if (!li.classList.contains('is-leaving')) return;
        li.hidden = true;
        li.classList.remove('is-leaving');
      }, 300);
    }

    function removeLine(li) {
      var variantId = li.getAttribute('data-variant-id');
      var title = li.getAttribute('data-title');
      var quantity = parseInt(li.getAttribute('data-qty'), 10) || 1;

      fadeOutLine(li);
      lastRemoved = { variantId: variantId, quantity: quantity };

      if (undoTextEl) undoTextEl.textContent = undoTpl.replace('[[title]]', title);
      if (undoEl) undoEl.hidden = false;
      announce(undoTextEl ? undoTextEl.textContent : liveRemoveMsg);

      clearTimeout(undoTimer);
      undoTimer = window.setTimeout(function () {
        if (undoEl) undoEl.hidden = true;
        lastRemoved = null;
      }, 9000);

      changeQuantity(variantId, 0, liveRemoveMsg);
    }

    function bindLine(li) {
      var variantId = li.getAttribute('data-variant-id');

      var stepper = li.querySelector('[data-cart-stepper]');
      if (stepper) {
        var input = stepper.querySelector('[data-cart-stepper-input]');
        var max = stepper.getAttribute('data-max');
        var decrease = stepper.querySelector('[data-cart-stepper-decrease]');
        var increase = stepper.querySelector('[data-cart-stepper-increase]');

        function apply(value) {
          value = Math.max(1, value);
          if (max) value = Math.min(parseInt(max, 10), value);
          input.value = value;
          li.setAttribute('data-qty', value);
          changeQuantity(variantId, value, liveQtyMsg);
        }

        if (decrease) {
          decrease.addEventListener('click', function () {
            apply((parseInt(input.value, 10) || 1) - 1);
          });
        }
        if (increase) {
          increase.addEventListener('click', function () {
            apply((parseInt(input.value, 10) || 1) + 1);
          });
        }
        if (input) {
          input.addEventListener('change', function () {
            apply(parseInt(input.value, 10) || 1);
          });
        }
      }

      var removeLink = li.querySelector('[data-cart-item-remove]');
      if (removeLink) {
        removeLink.addEventListener('click', function (event) {
          event.preventDefault();
          removeLine(li);
        });
      }
    }

    visibleLines().forEach(bindLine);

    if (undoBtn) {
      undoBtn.addEventListener('click', function () {
        if (!lastRemoved) return;
        var restore = lastRemoved;
        lastRemoved = null;
        clearTimeout(undoTimer);
        if (undoEl) undoEl.hidden = true;

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: restore.variantId, quantity: restore.quantity }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            return fetch(window.location.origin + '/cart.js');
          })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            announce(liveQtyMsg);
            applyCartResponse(cart, restore.variantId);
          });
      });
    }

    var sentinel = root.querySelector('.cart-sum');
    if ('IntersectionObserver' in window && sentinel && stickyBar) {
      new IntersectionObserver(
        function (entries) {
          if (!stickyBar.hasAttribute('data-force-hidden')) {
            stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
          }
        },
        { threshold: 0.15 }
      ).observe(sentinel);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-artwork"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function setupArtwork(root) {
      if (!root || root.getAttribute('data-artwork-ready') === 'true') return;
      root.setAttribute('data-artwork-ready', 'true');

      /* ---- Μικρογραφίες + μεγέθυνση ---- */
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.artwork-strip button'));
      var current = 0;
      var mainImg = root.querySelector('.artwork-main-img');
      var cap = root.querySelector('.artwork-shotcap');

      function selectThumb(i) {
        current = i;
        thumbs.forEach(function (t, j) {
          t.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
        var t = thumbs[i];
        var newSrc = t.getAttribute('data-src');
        if (mainImg && newSrc && mainImg.getAttribute('src') !== newSrc) {
          mainImg.classList.add('is-loading');
          var preload = new Image();
          preload.onload = function () {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = newSrc;
            mainImg.classList.remove('is-loading');
          };
          preload.onerror = function () {
            mainImg.classList.remove('is-loading');
          };
          preload.src = newSrc;
        }
        if (cap) cap.textContent = t.getAttribute('data-cap');
      }
      thumbs.forEach(function (b, i) {
        b.addEventListener('click', function () {
          selectThumb(i);
        });
      });

      /* ---- Lightbox ---- */
      var shot = root.querySelector('[data-artwork-shot]');
      var lb = root.parentElement.querySelector('[data-artwork-lb]') || document.querySelector('[data-artwork-lb]');
      if (shot && lb) {
        var lbImg = lb.querySelector('[data-artwork-lb-img]');
        var lbCap = lb.querySelector('[data-artwork-lb-cap]');
        var lbZoomBtn = lb.querySelector('[data-artwork-lb-zoom]');
        var lbStage = lb.querySelector('[data-artwork-lb-stage]');
        var lastFocus = null;

        function paint() {
          var t = thumbs[current] || null;
          var src = t ? t.getAttribute('data-src') : (mainImg ? mainImg.src : '');
          if (lbImg) {
            lbImg.src = src;
            lbImg.alt = t ? t.getAttribute('aria-label') || '' : '';
          }
          if (lbCap) lbCap.textContent = t ? t.getAttribute('data-cap') || '' : '';
        }
        function unzoom() {
          lb.classList.remove('is-zoomed');
          if (lbZoomBtn) {
            lbZoomBtn.textContent = lbZoomBtn.getAttribute('data-zoom-label');
            lbZoomBtn.setAttribute('aria-pressed', 'false');
          }
          if (lbStage) {
            lbStage.scrollTop = 0;
            lbStage.scrollLeft = 0;
          }
        }
        function trapItems() {
          return Array.prototype.slice.call(lb.querySelectorAll('button'));
        }
        function onKeydown(e) {
          if (e.key === 'Escape') {
            close();
            return;
          }
          if (e.key === 'ArrowLeft') step(-1);
          if (e.key === 'ArrowRight') step(1);
          if (e.key === 'Tab') {
            var items = trapItems();
            if (!items.length) return;
            var first = items[0];
            var last = items[items.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
        function open() {
          lastFocus = document.activeElement;
          paint();
          unzoom();
          clearTimeout(closeTimer);
          lb.classList.remove('is-closing');
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
          document.addEventListener('keydown', onKeydown);
          var closeBtn = lb.querySelector('[data-artwork-lb-close]');
          if (closeBtn) closeBtn.focus();
        }
        var closeTimer = null;
        function close() {
          // Σβήνει ομαλά πριν κρυφτεί (βλ. .artwork-lb.is-closing).
          lb.classList.add('is-closing');
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            lb.hidden = true;
            lb.classList.remove('is-closing');
          }, 250);
          document.body.style.overflow = '';
          document.removeEventListener('keydown', onKeydown);
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }
        function step(d) {
          if (!thumbs.length) return;
          current = (current + d + thumbs.length) % thumbs.length;
          selectThumb(current);
          paint();
          unzoom();
        }

        shot.addEventListener('click', open);
        shot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
          }
        });
        var closeBtn = lb.querySelector('[data-artwork-lb-close]');
        if (closeBtn) closeBtn.addEventListener('click', close);
        var prevBtn = lb.querySelector('[data-artwork-lb-prev]');
        if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
        var nextBtn = lb.querySelector('[data-artwork-lb-next]');
        if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
        if (lbZoomBtn) {
          lbZoomBtn.addEventListener('click', function () {
            if (lb.classList.contains('is-zoomed')) {
              unzoom();
              return;
            }
            lb.classList.add('is-zoomed');
            lbZoomBtn.textContent = lbZoomBtn.getAttribute('data-unzoom-label');
            lbZoomBtn.setAttribute('aria-pressed', 'true');
            if (lbStage) {
              lbStage.scrollLeft = (lbStage.scrollWidth - lbStage.clientWidth) / 2;
              lbStage.scrollTop = (lbStage.scrollHeight - lbStage.clientHeight) / 3;
            }
          });
        }
        if (lbStage) {
          lbStage.addEventListener('click', function (e) {
            if (e.target === lbStage) close();
          });

          var down = false, sx = 0, sy = 0, sl = 0, st = 0;
          lbStage.addEventListener('mousedown', function (e) {
            if (!lb.classList.contains('is-zoomed')) return;
            down = true;
            sx = e.clientX; sy = e.clientY;
            sl = lbStage.scrollLeft; st = lbStage.scrollTop;
            lbStage.style.cursor = 'grabbing';
            e.preventDefault();
          });
          window.addEventListener('mousemove', function (e) {
            if (!down) return;
            lbStage.scrollLeft = sl - (e.clientX - sx);
            lbStage.scrollTop = st - (e.clientY - sy);
          });
          window.addEventListener('mouseup', function () {
            down = false;
            lbStage.style.cursor = '';
          });
        }
      }

      /* ---- Δωμάτιο κλίμακας: το έργο κρέμεται με το ΚΕΝΤΡΟ του σε
              ρυθμιζόμενο ύψος από το πάτωμα (μουσειακός κανόνας). ---- */
      var svg = root.querySelector('[id^="artwork-scale-svg-"]');
      if (svg) {
        var U = 2, FLOOR = 540, CX = 500;
        var w = parseFloat(svg.getAttribute('data-w'));
        var h = parseFloat(svg.getAttribute('data-h'));
        var centerCm = parseFloat(svg.getAttribute('data-center')) || 150;
        var pw = w * U, ph = h * U;
        var x = CX - pw / 2, y = FLOOR - centerCm * U - ph / 2;

        function set(el, attrs) {
          if (!el) return;
          for (var k in attrs) el.setAttribute(k, attrs[k]);
        }

        var img = svg.querySelector('[id^="artwork-hung-"]:not([id*="frame"])');
        var frame = svg.querySelector('[id^="artwork-hung-frame-"]');
        set(img, { x: x, y: y, width: pw, height: ph });
        set(frame, { x: x, y: y, width: pw, height: ph, fill: 'none' });

        var nailY = y - 26;
        set(svg.querySelector('[id^="artwork-wireL-"]'), { d: 'M' + CX + ' ' + nailY + ' L' + (x + 10) + ' ' + (y + 4) });
        set(svg.querySelector('[id^="artwork-wireR-"]'), { d: 'M' + CX + ' ' + nailY + ' L' + (x + pw - 10) + ' ' + (y + 4) });
        set(svg.querySelector('[id^="artwork-nail-"]'), {
          d: 'M' + (CX - 4) + ' ' + (nailY - 4) + ' C' + (CX - 4) + ' ' + (nailY - 8) + ' ' + (CX + 4) + ' ' + (nailY - 8) + ' ' + (CX + 4) + ' ' + (nailY - 4) +
            ' C' + (CX + 4) + ' ' + nailY + ' ' + (CX - 4) + ' ' + nailY + ' ' + (CX - 4) + ' ' + (nailY - 4) + ' Z',
        });

        var vx = x - 26;
        set(svg.querySelector('[id^="artwork-dimV-"]'), {
          d: 'M' + vx + ' ' + y + ' L' + vx + ' ' + (y + ph) + ' M' + (vx - 5) + ' ' + y + ' L' + (vx + 5) + ' ' + y +
            ' M' + (vx - 5) + ' ' + (y + ph) + ' L' + (vx + 5) + ' ' + (y + ph),
        });
        var vt = svg.querySelector('[id^="artwork-dimVt-"]');
        if (vt) {
          vt.textContent = h + ' εκ.';
          set(vt, { x: vx - 10, y: y + ph / 2 + 5 });
        }

        var hy = y + ph + 24;
        set(svg.querySelector('[id^="artwork-dimH-"]'), {
          d: 'M' + x + ' ' + hy + ' L' + (x + pw) + ' ' + hy + ' M' + x + ' ' + (hy - 5) + ' L' + x + ' ' + (hy + 5) +
            ' M' + (x + pw) + ' ' + (hy - 5) + ' L' + (x + pw) + ' ' + (hy + 5),
        });
        var ht = svg.querySelector('[id^="artwork-dimHt-"]');
        if (ht) {
          ht.textContent = w + ' εκ.';
          set(ht, { x: CX, y: hy + 19 });
        }

        if (window.ArtnikolinaScaleFit) window.ArtnikolinaScaleFit(svg, 'artwork');

        var noteEl = root.querySelector('[id^="artwork-scale-note-"]');
        var refButtons = Array.prototype.slice.call(root.querySelectorAll('.artwork-refs button'));
        var notes = {};
        refButtons.forEach(function (b) {
          notes[b.getAttribute('data-ref')] = b.getAttribute('data-note') || '';
        });
        function paintNote(ref) {
          if (noteEl) noteEl.textContent = notes[ref] || '';
        }
        refButtons.forEach(function (b) {
          b.addEventListener('click', function () {
            refButtons.forEach(function (x) {
              x.setAttribute('aria-pressed', 'false');
              var g = svg.querySelector('[data-ref-group="' + x.getAttribute('data-ref') + '"]');
              if (g) g.style.display = 'none';
            });
            b.setAttribute('aria-pressed', 'true');
            var g = svg.querySelector('[data-ref-group="' + b.getAttribute('data-ref') + '"]');
            if (g) g.style.display = '';
            if (window.ArtnikolinaScaleFit) window.ArtnikolinaScaleFit(svg, 'artwork');
            paintNote(b.getAttribute('data-ref'));
          });
        });
        paintNote('console');
      }
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('.artwork-product[data-section-id]'), setupArtwork);
    }

    ready(init);

    document.addEventListener('shopify:section:load', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var root = document.querySelector('.artwork-product[data-section-id="' + id + '"]');
      if (root) {
        root.removeAttribute('data-artwork-ready');
        setupArtwork(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-glow"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function setupGlow(root) {
      if (!root || root.getAttribute('data-glow-ready') === 'true') return;
      root.setAttribute('data-glow-ready', 'true');

      /* ---- Σβήσε το φως ---- */
      var stage = root.querySelector('[data-glow-stage]');
      var lightsBtn = root.querySelector('[data-glow-lights]');
      var lightsHint = stage ? stage.parentElement.querySelector('.glow-lights-hint') : null;

      if (stage && lightsBtn) {
        lightsBtn.addEventListener('click', function () {
          var night = stage.classList.toggle('is-night');
          lightsBtn.setAttribute('aria-pressed', night);
          lightsBtn.textContent = night
            ? lightsBtn.getAttribute('data-off-label')
            : lightsBtn.getAttribute('data-on-label');
          if (lightsHint) {
            lightsHint.textContent = night
              ? lightsHint.getAttribute('data-night-text')
              : lightsHint.getAttribute('data-day-text');
          }
        });
      }

      /* ---- Μικρογραφίες + μεγέθυνση ---- */
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.glow-strip button'));
      var current = 0;
      var dayImg = root.querySelector('.glow-day-img');
      var nightImg = root.querySelector('.glow-night-img');
      var cap = root.querySelector('.glow-shotcap');

      function selectThumb(i) {
        current = i;
        thumbs.forEach(function (t, j) {
          t.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
        var t = thumbs[i];
        var newSrc = t.getAttribute('data-day');
        if (dayImg && newSrc && dayImg.getAttribute('src') !== newSrc) {
          dayImg.classList.add('is-loading');
          var preload = new Image();
          preload.onload = function () {
            dayImg.removeAttribute('srcset');
            dayImg.removeAttribute('sizes');
            dayImg.src = newSrc;
            dayImg.classList.remove('is-loading');
          };
          preload.onerror = function () {
            dayImg.classList.remove('is-loading');
          };
          preload.src = newSrc;
        }
        var night = t.getAttribute('data-night');
        if (night) {
          if (nightImg) {
            nightImg.removeAttribute('srcset');
            nightImg.removeAttribute('sizes');
            nightImg.src = night;
            nightImg.style.display = '';
          }
          if (lightsBtn) lightsBtn.closest('.glow-lights') && (lightsBtn.closest('.glow-lights').style.display = '');
        } else {
          if (nightImg) nightImg.style.display = 'none';
          if (stage) stage.classList.remove('is-night');
          if (lightsBtn) {
            lightsBtn.setAttribute('aria-pressed', 'false');
            lightsBtn.textContent = lightsBtn.getAttribute('data-on-label');
            var lightsWrap = lightsBtn.closest('.glow-lights');
            if (lightsWrap) lightsWrap.style.display = 'none';
          }
        }
        if (cap) cap.textContent = t.getAttribute('data-cap');
      }
      thumbs.forEach(function (b, i) {
        b.addEventListener('click', function () {
          selectThumb(i);
        });
      });

      /* ---- Lightbox ---- */
      var shot = root.querySelector('[data-glow-shot]');
      var lb = root.parentElement.querySelector('[data-glow-lb]') || document.querySelector('[data-glow-lb]');
      if (shot && lb) {
        var lbImg = lb.querySelector('[data-glow-lb-img]');
        var lbCap = lb.querySelector('[data-glow-lb-cap]');
        var lbZoomBtn = lb.querySelector('[data-glow-lb-zoom]');
        var lbStage = lb.querySelector('[data-glow-lb-stage]');
        var lastFocus = null;

        function paint() {
          var t = thumbs[current] || null;
          var day = t ? t.getAttribute('data-day') : (dayImg ? dayImg.src : '');
          var night = t ? t.getAttribute('data-night') : null;
          var isNight = stage && stage.classList.contains('is-night') && night;
          if (lbImg) {
            lbImg.src = isNight ? night : day;
            lbImg.alt = t ? t.getAttribute('aria-label') || '' : '';
          }
          if (lbCap) lbCap.textContent = t ? t.getAttribute('data-cap') || '' : '';
        }
        function unzoom() {
          lb.classList.remove('is-zoomed');
          if (lbZoomBtn) {
            lbZoomBtn.textContent = lbZoomBtn.getAttribute('data-zoom-label');
            lbZoomBtn.setAttribute('aria-pressed', 'false');
          }
          if (lbStage) {
            lbStage.scrollTop = 0;
            lbStage.scrollLeft = 0;
          }
        }
        function trapItems() {
          return Array.prototype.slice.call(lb.querySelectorAll('button'));
        }
        function onKeydown(e) {
          if (e.key === 'Escape') {
            close();
            return;
          }
          if (e.key === 'ArrowLeft') step(-1);
          if (e.key === 'ArrowRight') step(1);
          if (e.key === 'Tab') {
            var items = trapItems();
            if (!items.length) return;
            var first = items[0];
            var last = items[items.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
        function open() {
          lastFocus = document.activeElement;
          paint();
          unzoom();
          clearTimeout(closeTimer);
          lb.classList.remove('is-closing');
          lb.hidden = false;
          document.body.style.overflow = 'hidden';
          document.addEventListener('keydown', onKeydown);
          var closeBtn = lb.querySelector('[data-glow-lb-close]');
          if (closeBtn) closeBtn.focus();
        }
        var closeTimer = null;
        function close() {
          // Σβήνει ομαλά πριν κρυφτεί (βλ. .glow-lb.is-closing).
          lb.classList.add('is-closing');
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            lb.hidden = true;
            lb.classList.remove('is-closing');
          }, 250);
          document.body.style.overflow = '';
          document.removeEventListener('keydown', onKeydown);
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }
        function step(d) {
          if (!thumbs.length) return;
          current = (current + d + thumbs.length) % thumbs.length;
          selectThumb(current);
          paint();
          unzoom();
        }

        shot.addEventListener('click', open);
        shot.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
          }
        });
        var closeBtn = lb.querySelector('[data-glow-lb-close]');
        if (closeBtn) closeBtn.addEventListener('click', close);
        var prevBtn = lb.querySelector('[data-glow-lb-prev]');
        if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
        var nextBtn = lb.querySelector('[data-glow-lb-next]');
        if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
        if (lbZoomBtn) {
          lbZoomBtn.addEventListener('click', function () {
            if (lb.classList.contains('is-zoomed')) {
              unzoom();
              return;
            }
            lb.classList.add('is-zoomed');
            lbZoomBtn.textContent = lbZoomBtn.getAttribute('data-unzoom-label');
            lbZoomBtn.setAttribute('aria-pressed', 'true');
            if (lbStage) {
              lbStage.scrollLeft = (lbStage.scrollWidth - lbStage.clientWidth) / 2;
              lbStage.scrollTop = (lbStage.scrollHeight - lbStage.clientHeight) / 3;
            }
          });
        }
        if (lbStage) {
          lbStage.addEventListener('click', function (e) {
            if (e.target === lbStage) close();
          });

          var down = false, sx = 0, sy = 0, sl = 0, st = 0;
          lbStage.addEventListener('mousedown', function (e) {
            if (!lb.classList.contains('is-zoomed')) return;
            down = true;
            sx = e.clientX; sy = e.clientY;
            sl = lbStage.scrollLeft; st = lbStage.scrollTop;
            lbStage.style.cursor = 'grabbing';
            e.preventDefault();
          });
          window.addEventListener('mousemove', function (e) {
            if (!down) return;
            lbStage.scrollLeft = sl - (e.clientX - sx);
            lbStage.scrollTop = st - (e.clientY - sy);
          });
          window.addEventListener('mouseup', function () {
            down = false;
            lbStage.style.cursor = '';
          });
        }
      }

      /* ---- Δωμάτιο κλίμακας ---- */
      var svg = root.querySelector('[id^="glow-scale-svg-"]');
      if (svg) {
        var U = 2, FLOOR = 540, CX = 500;
        var w = parseFloat(svg.getAttribute('data-w'));
        var h = parseFloat(svg.getAttribute('data-h'));
        var bottomCm = parseFloat(svg.getAttribute('data-hang')) || 110;
        var pw = w * U, ph = h * U;
        var x = CX - pw / 2, y = FLOOR - bottomCm * U - ph;

        function set(el, attrs) {
          if (!el) return;
          for (var k in attrs) el.setAttribute(k, attrs[k]);
        }

        var img = svg.querySelector('[id^="glow-hung-"]:not([id*="frame"])');
        var frame = svg.querySelector('[id^="glow-hung-frame-"]');
        set(img, { x: x, y: y, width: pw, height: ph });
        set(frame, { x: x, y: y, width: pw, height: ph, fill: 'none' });

        var nailY = y - 26;
        set(svg.querySelector('[id^="glow-wireL-"]'), { d: 'M' + CX + ' ' + nailY + ' L' + (x + 10) + ' ' + (y + 4) });
        set(svg.querySelector('[id^="glow-wireR-"]'), { d: 'M' + CX + ' ' + nailY + ' L' + (x + pw - 10) + ' ' + (y + 4) });
        set(svg.querySelector('[id^="glow-nail-"]'), {
          d: 'M' + (CX - 4) + ' ' + (nailY - 4) + ' C' + (CX - 4) + ' ' + (nailY - 8) + ' ' + (CX + 4) + ' ' + (nailY - 8) + ' ' + (CX + 4) + ' ' + (nailY - 4) +
            ' C' + (CX + 4) + ' ' + nailY + ' ' + (CX - 4) + ' ' + nailY + ' ' + (CX - 4) + ' ' + (nailY - 4) + ' Z',
        });

        var vx = x - 26;
        set(svg.querySelector('[id^="glow-dimV-"]'), {
          d: 'M' + vx + ' ' + y + ' L' + vx + ' ' + (y + ph) + ' M' + (vx - 5) + ' ' + y + ' L' + (vx + 5) + ' ' + y +
            ' M' + (vx - 5) + ' ' + (y + ph) + ' L' + (vx + 5) + ' ' + (y + ph),
        });
        var vt = svg.querySelector('[id^="glow-dimVt-"]');
        if (vt) {
          vt.textContent = h + ' εκ.';
          set(vt, { x: vx - 10, y: y + ph / 2 + 5 });
        }

        var hy = y + ph + 24;
        set(svg.querySelector('[id^="glow-dimH-"]'), {
          d: 'M' + x + ' ' + hy + ' L' + (x + pw) + ' ' + hy + ' M' + x + ' ' + (hy - 5) + ' L' + x + ' ' + (hy + 5) +
            ' M' + (x + pw) + ' ' + (hy - 5) + ' L' + (x + pw) + ' ' + (hy + 5),
        });
        var ht = svg.querySelector('[id^="glow-dimHt-"]');
        if (ht) {
          ht.textContent = w + ' εκ.';
          set(ht, { x: CX, y: hy + 19 });
        }

        if (window.ArtnikolinaScaleFit) window.ArtnikolinaScaleFit(svg, 'glow');

        var noteEl = root.querySelector('[id^="glow-scale-note-"]');
        var refButtons = Array.prototype.slice.call(root.querySelectorAll('.glow-refs button'));
        var notes = {};
        refButtons.forEach(function (b) {
          notes[b.getAttribute('data-ref')] = b.getAttribute('data-note') || '';
        });
        function paintNote(ref) {
          if (noteEl) noteEl.textContent = notes[ref] || '';
        }
        refButtons.forEach(function (b) {
          b.addEventListener('click', function () {
            refButtons.forEach(function (x) {
              x.setAttribute('aria-pressed', 'false');
              var g = svg.querySelector('[data-ref-group="' + x.getAttribute('data-ref') + '"]');
              if (g) g.style.display = 'none';
            });
            b.setAttribute('aria-pressed', 'true');
            var g = svg.querySelector('[data-ref-group="' + b.getAttribute('data-ref') + '"]');
            if (g) g.style.display = '';
            if (window.ArtnikolinaScaleFit) window.ArtnikolinaScaleFit(svg, 'glow');
            paintNote(b.getAttribute('data-ref'));
          });
        });
        paintNote('console');
      }
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('.glow-product[data-section-id]'), setupGlow);
    }

    ready(init);

    document.addEventListener('shopify:section:load', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var root = document.querySelector('.glow-product[data-section-id="' + id + '"]');
      if (root) {
        root.removeAttribute('data-glow-ready');
        setupGlow(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-paints"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function formatMoney(cents, currency, locale) {
      try {
        return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function setupPaints(root) {
      if (!root || root.getAttribute('data-paints-ready') === 'true') return;
      root.setAttribute('data-paints-ready', 'true');

      var currency = root.getAttribute('data-currency');
      var locale = root.getAttribute('data-locale');

      var qtyInput = root.querySelector('[data-paints-qty]');
      var addPriceEl = root.querySelector('[data-paints-add-price]');
      var barPriceEl = document.querySelector('[data-paints-bar-price]');
      var nudgeEl = root.querySelector('[data-paints-nudge]');
      var nudgeTextEl = root.querySelector('[data-paints-nudge-text]');
      var fillEl = root.querySelector('[data-paints-fill]');
      var sizeInputs = Array.prototype.slice.call(root.querySelectorAll('.paints-sizes input'));

      if (!qtyInput) return;

      function selectedVariant() {
        var checked = root.querySelector('.paints-sizes input:checked');
        return checked || sizeInputs[0] || null;
      }

      function render() {
        var variant = selectedVariant();
        var price = variant ? parseInt(variant.getAttribute('data-paints-price'), 10) || 0 : 0;
        var max = variant ? parseInt(variant.getAttribute('data-paints-max'), 10) : NaN;
        var qty = parseInt(qtyInput.value, 10) || 1;
        if (qty < 1) qty = 1;
        if (!isNaN(max) && max > 0 && qty > max) qty = max;
        qtyInput.value = qty;

        var sum = price * qty;
        var formatted = formatMoney(sum, currency, locale);
        if (addPriceEl) addPriceEl.textContent = formatted;
        if (barPriceEl) barPriceEl.textContent = formatted;

        if (nudgeEl && nudgeTextEl) {
          var threshold = parseInt(nudgeEl.getAttribute('data-threshold-cents'), 10) || 0;
          var subtotal = parseInt(nudgeEl.getAttribute('data-cart-subtotal-cents'), 10) || 0;
          var total = subtotal + sum;
          var rest = threshold - total;
          var percent;
          if (threshold > 0 && rest > 0) {
            nudgeTextEl.textContent = nudgeEl.getAttribute('data-progress-text').replace('[[amount]]', formatMoney(rest, currency, locale));
            percent = Math.max(4, Math.min(100, (total / threshold) * 100));
          } else {
            nudgeTextEl.textContent = nudgeEl.getAttribute('data-done-text');
            percent = 100;
          }
          if (fillEl) fillEl.style.width = percent + '%';
        }
      }

      var acts = root.querySelector('.paints-acts');
      if (acts) {
        acts.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-paints-step]');
          if (!btn) return;
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-paints-step'), 10);
          render();
        });
      }
      qtyInput.addEventListener('change', render);
      sizeInputs.forEach(function (input) {
        input.addEventListener('change', render);
      });

      /* ---- Αν το χρώμα είναι ανοιχτό, το κείμενο πάνω του γίνεται σκούρο ---- */
      var field = root.querySelector('.paints-field');
      if (field) {
        var hue = getComputedStyle(root).getPropertyValue('--hue').trim();
        var m = hue.match(/^#?([0-9a-f]{6})$/i);
        if (m) {
          var v = parseInt(m[1], 16);
          var lum = (0.2126 * ((v >> 16) & 255) + 0.7152 * ((v >> 8) & 255) + 0.0722 * (v & 255)) / 255;
          if (lum > 0.62) field.classList.add('is-light');
        }
      }

      render();
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('.paints-product[data-section-id]'), setupPaints);
    }

    ready(init);

    document.addEventListener('shopify:section:load', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var root = document.querySelector('.paints-product[data-section-id="' + id + '"]');
      if (root) {
        root.removeAttribute('data-paints-ready');
        setupPaints(root);
      }
    });
  })();

  document.querySelectorAll('[data-atelier-add-to-cart]').forEach(function (button) {
    var form = button.closest('form');
    if (!form) return;

    var behaviorRoot = button.closest('[data-cart-add-behavior]');
    var behaviorMode = behaviorRoot ? behaviorRoot.getAttribute('data-cart-add-behavior') : 'smart';
    var cartUrl = behaviorRoot ? behaviorRoot.getAttribute('data-cart-url') : '/cart';

    var label = button.querySelector('[data-atelier-add-to-cart-label]');
    var message = form.querySelector('[data-atelier-add-to-cart-message]');
    var defaultLabel = label ? label.textContent : '';
    var addingLabel = button.getAttribute('data-adding-label');
    var errorLabel = button.getAttribute('data-error-label');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (message) {
        message.hidden = true;
        message.textContent = '';
      }
      button.disabled = true;
      if (label && addingLabel) label.textContent = addingLabel;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          button.disabled = false;
          if (label) label.textContent = defaultLabel;

          if (!result.ok) {
            if (message) {
              message.hidden = false;
              message.textContent = result.data.description || errorLabel;
            }
            return;
          }

          if (behaviorMode === 'page') {
            window.location.href = cartUrl;
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch(function () {
          button.disabled = false;
          if (label) label.textContent = defaultLabel;
          if (message) {
            message.hidden = false;
            message.textContent = errorLabel;
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-set"]) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    function formatMoney(cents, currency, locale) {
      try {
        return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function hexOf(styles, name) {
      var m = styles.getPropertyValue(name).trim().match(/^#?([0-9a-f]{6})$/i);
      if (!m) return null;
      var v = parseInt(m[1], 16);
      return [(v >> 16) & 255, (v >> 8) & 255, v & 255];
    }

    function setupSet(root) {
      if (!root || root.getAttribute('data-set-ready') === 'true') return;
      root.setAttribute('data-set-ready', 'true');

      var styles = getComputedStyle(root);
      var currency = root.getAttribute('data-currency');
      var locale = root.getAttribute('data-locale');

      /* ---- Σε ανοιχτή λωρίδα, το όνομα γίνεται σκούρο ---- */
      Array.prototype.forEach.call(root.querySelectorAll('.set-band[data-set-var]'), function (band) {
        var c = hexOf(styles, band.getAttribute('data-set-var'));
        if (!c) return;
        var lum = (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255;
        if (lum > 0.62) band.classList.add('is-light');
      });

      /* ---- Αναμειγνύει τα --c1…--cN με τις αναλογίες του data-set-parts ---- */
      Array.prototype.forEach.call(root.querySelectorAll('[data-set-parts]'), function (el) {
        var tot = 0;
        var acc = [0, 0, 0];
        var ok = true;
        el.getAttribute('data-set-parts').split(',').forEach(function (p) {
          var kv = p.split(':');
          var c = hexOf(styles, '--' + kv[0].trim().toLowerCase());
          var w = parseFloat(kv[1]);
          if (!c || !(w > 0)) {
            ok = false;
            return;
          }
          tot += w;
          for (var i = 0; i < 3; i++) acc[i] += c[i] * w;
        });
        if (ok && tot) {
          el.style.background = 'rgb(' + acc.map(function (x) { return Math.round(x / tot); }).join(',') + ')';
        }
      });

      /* ---- Ποσότητα, τιμή, ώθηση για δωρεάν αποστολή ---- */
      var form = root.querySelector('.set-form');
      if (!form) return;

      var qtyInput = form.querySelector('[data-set-qty]');
      var addBtn = form.querySelector('[data-set-add-to-cart]');
      var addPriceEl = form.querySelector('[data-set-add-price]');
      var barPriceEl = root.querySelector('[data-set-bar-price]');
      var nudgeEl = form.querySelector('[data-set-nudge]');
      var fillEl = form.querySelector('[data-set-fill]');
      var liveEl = form.querySelector('[data-set-live]');
      var price = parseInt(addBtn.getAttribute('data-set-price'), 10) || 0;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 10;

      function escapeHtml(s) {
        return s.replace(/[&<>"]/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
        });
      }

      function render() {
        var qty = parseInt(qtyInput.value, 10) || 1;
        qty = Math.min(max, Math.max(1, qty));
        qtyInput.value = qty;

        var sum = price * qty;
        var formatted = formatMoney(sum, currency, locale);
        if (addPriceEl) addPriceEl.textContent = formatted;
        if (barPriceEl) barPriceEl.textContent = formatted;

        if (nudgeEl) {
          var threshold = parseInt(nudgeEl.getAttribute('data-threshold-cents'), 10) || 0;
          var rest = threshold - sum;
          var textEl = nudgeEl.querySelector('[data-set-nudge-text]');
          var linkEl = nudgeEl.querySelector('[data-set-nudge-link]');
          if (rest > 0) {
            textEl.innerHTML = nudgeEl
              .getAttribute('data-progress-html')
              .replace('[[amount]]', '<b>' + escapeHtml(formatMoney(rest, currency, locale)) + '</b>');
            if (linkEl) linkEl.hidden = false;
            if (fillEl) fillEl.style.width = Math.max(4, (sum / threshold) * 100) + '%';
          } else {
            textEl.innerHTML = nudgeEl.getAttribute('data-done-html');
            if (linkEl) linkEl.hidden = true;
            if (fillEl) fillEl.style.width = '100%';
          }
        }
        return qty;
      }

      form.addEventListener('click', function (e) {
        var step = e.target.closest('[data-set-step]');
        if (!step) return;
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-set-step'), 10);
        var qty = render();
        if (liveEl) liveEl.textContent = String(qty);
      });
      qtyInput.addEventListener('change', render);

      /* ---- Προσθήκη στο καλάθι (δικός του handler, για να μη διπλασιάζεται) ---- */
      var behaviorMode = root.getAttribute('data-cart-add-behavior') || 'smart';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var label = addBtn.querySelector('[data-set-add-label]');
      var message = form.querySelector('[data-set-add-message]');
      var defaultLabel = label ? label.textContent : '';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (addBtn.disabled) return;

        if (message) {
          message.hidden = true;
          message.textContent = '';
        }
        addBtn.disabled = true;
        if (label) label.textContent = addBtn.getAttribute('data-adding-label');

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            addBtn.disabled = false;
            if (label) label.textContent = defaultLabel;

            if (!result.ok) {
              if (message) {
                message.hidden = false;
                message.textContent = result.data.description || addBtn.getAttribute('data-error-label');
              }
              return;
            }

            if (behaviorMode === 'page') {
              window.location.href = cartUrl;
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          })
          .catch(function () {
            addBtn.disabled = false;
            if (label) label.textContent = defaultLabel;
            if (message) {
              message.hidden = false;
              message.textContent = addBtn.getAttribute('data-error-label');
            }
          });
      });

      render();
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('.set-product[data-section-id]'), setupSet);
    }

    ready(init);

    document.addEventListener('shopify:section:load', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (!id) return;
      var root = document.querySelector('.set-product[data-section-id="' + id + '"]');
      if (root) {
        root.removeAttribute('data-set-ready');
        setupSet(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Μικρογραφίες: δείχνουν το αντίστοιχο μέσο στην κύρια θέση. */
  document.querySelectorAll('.atelier-product__thumbs').forEach(function (thumbs) {
    var media = thumbs.closest('.atelier-product__media');
    var stage = media ? media.querySelector('[data-product-stage]') : null;
    if (!stage) return;
    var items = stage.querySelectorAll('[data-media-index]');
    var buttons = thumbs.querySelectorAll('[data-media-thumb]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-media-thumb');
        items.forEach(function (item) {
          var show = item.getAttribute('data-media-index') === target;
          if (!show) {
            item.querySelectorAll('video').forEach(function (video) { video.pause(); });
          }
          item.hidden = !show;
        });
        buttons.forEach(function (other) {
          other.setAttribute('aria-current', other === button ? 'true' : 'false');
        });
      });
    });
  });

  document.querySelectorAll('[data-atelier-add-to-cart]').forEach(function (button) {
    var form = button.closest('form');
    if (!form) return;

    var behaviorRoot = button.closest('[data-cart-add-behavior]');
    var behaviorMode = behaviorRoot ? behaviorRoot.getAttribute('data-cart-add-behavior') : 'smart';
    var cartUrl = behaviorRoot ? behaviorRoot.getAttribute('data-cart-url') : '/cart';

    var label = button.querySelector('[data-atelier-add-to-cart-label]');
    var message = form.querySelector('[data-atelier-add-to-cart-message]');
    var defaultLabel = label ? label.textContent : '';
    var addingLabel = button.getAttribute('data-adding-label');
    var errorLabel = button.getAttribute('data-error-label');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (message) {
        message.hidden = true;
        message.textContent = '';
      }
      button.disabled = true;
      if (label && addingLabel) label.textContent = addingLabel;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          button.disabled = false;
          if (label) label.textContent = defaultLabel;

          if (!result.ok) {
            if (message) {
              message.hidden = false;
              message.textContent = result.data.description || errorLabel;
            }
            return;
          }

          if (behaviorMode === 'page') {
            window.location.href = cartUrl;
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch(function () {
          button.disabled = false;
          if (label) label.textContent = defaultLabel;
          if (message) {
            message.hidden = false;
            message.textContent = errorLabel;
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
